export default __webpack_public_path__ + "static/media/NaturalBodybuilder.f820becd.png";